import i18n from 'commons/libs/i18n'
import { formatDate, isDateAfter, isSameDate } from 'commons/utils/date'
import { SampleOrderCostElement } from 'constants/enums'
import * as yup from 'yup'

export const formSchema = yup.object().shape({
  cd_canl_dstb: yup.string().required(() => i18n.t('common.validations.required')),
  cd_cent_cust: yup.string().when('op_elem_cust', {
    is: (costElement: SampleOrderCostElement) => costElement === SampleOrderCostElement.COST,
    otherwise: (schema) => schema.notRequired(),
    then: (schema) => schema.required(() => i18n.t('common.validations.required')),
  }),
  cd_clie: yup.object().shape({
    cd_clie: yup.string().required(() => i18n.t('common.validations.required')),
  }),
  cd_cond_pgto: yup.string().required(() => i18n.t('common.validations.required')),
  cd_elem_pep: yup.string().when(['op_elem_cust'], {
    is: (costElement: SampleOrderCostElement) => costElement === SampleOrderCostElement.PEP,
    otherwise: (schema) => schema.notRequired(),
    then: (schema) => schema.required(() => i18n.t('common.validations.required')),
  }),
  cd_escr_vend: yup.string().required(() => i18n.t('common.validations.required')),
  cd_inco: yup.string().required(() => i18n.t('common.validations.required')),
  cd_mes_entr: yup
    .string()
    .nullable()
    .required(() => i18n.t('common.validations.required'))
    .test(
      'isSameOrAfterDate',
      () => i18n.t('common.validations.isSameOrAfterDate'),
      function (date) {
        if (!date) return false

        const formatedDate = formatDate(date, 'YYYY-MM')
        const today = formatDate(new Date(), 'YYYY-MM')

        return isSameDate(formatedDate, today) || isDateAfter(formatedDate, today)
      },
    ),
  cd_mes_fatm: yup
    .string()
    .nullable()
    .required(() => i18n.t('common.validations.required'))
    .test(
      'isSameOrAfterMonth',
      () => i18n.t('common.validations.isSameOrAfterMonth'),
      function (date) {
        if (!date) return false

        const formatedDate = formatDate(date, 'YYYY-MM')
        const today = formatDate(new Date(), 'YYYY-MM')

        return isSameDate(formatedDate, today) || isDateAfter(formatedDate, today)
      },
    ),
  cd_moti_prom: yup.string().required(() => i18n.t('common.validations.required')),
  cd_orgn_vend: yup.string().required(() => i18n.t('common.validations.required')),
  cd_seto_atvd: yup.string().required(() => i18n.t('common.validations.required')),
  cd_tipo_orde: yup.string().required(() => i18n.t('common.validations.required')),
  ds_armz: yup.string().required(() => i18n.t('common.validations.required')),
  dt_dsjd_pedi: yup
    .string()
    .nullable()
    .required(() => i18n.t('common.validations.required'))
    .test(
      'isSameOrAfterDate',
      () => i18n.t('common.validations.isSameOrAfterDate'),
      function (date) {
        if (!date) return false

        const formatedDate = formatDate(date, 'YYYY-MM-DD')
        const today = formatDate(new Date(), 'YYYY-MM-DD')

        return isSameDate(formatedDate, today) || isDateAfter(formatedDate, today)
      },
    ),
  // TODO: Comment until YASC next steps in 2026
  // fl_cbtr_camb: yup
  //   .string()
  //   .oneOf([TypesValidations.YES, TypesValidations.NO])
  //   .required(() => i18n.t('common.validations.required')),
  op_elem_cust: yup.string().required(() => i18n.t('common.validations.required')),
})
